<template>
    <div class="columns is-multiline">
        <div class="column is-12">
            <b-button @click="addRow" type="is-info" size="is-small" icon-left="plus">Add Row</b-button>
            <table class="table is-bordered">
                <tbody>
                    <tr v-for="(row, row_index) in multi_chars.data" :key="`ROW-${row_index}`">
                        <td v-for="(col, col_index) in row" :key="`ROW-${row_index}-COL-${col_index}`">
                            <up-select size="sm" v-model="col.type" label="Type" labelIcon="mdi mdi-alpha-t-box-outline">
                                <option value="T">Text</option>
                                <option value="I">Input</option>
                            </up-select>
                            <up-select v-if="col.type == 'I'" v-model="col.inp_size" label="Size" labelIcon="mdi mdi-alpha-s-box-outline">
                              <option value="xxs">Extra Extra Small</option>
                              <option value="xs">Extra Small</option>
                              <option value="sm">Small</option>
                              <option value="md">Medium</option>
                              <option value="lg">Large</option>
                            </up-select>
                            <up-textinput size="sm" v-model="col.value" label="Value" labelIcon="mdi mdi-alpha-v-box-outline"/>

                            <b-button size="is-small" type="is-danger"  @click="removeColumn(row_index, col_index)" icon-left="close"></b-button>
                        </td>
                        <td>
                            <div class="buttons">
                                <b-button size="is-small" type="is-info"  @click="addColumn(row_index)" icon-left="plus"></b-button>
                                <b-button size="is-small" type="is-danger"  @click="removeRow(row_index)" icon-left="close"></b-button>
                            </div>
                            
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="column is-12">
            <style-editor
            title="Cell"
            v-model="multi_chars.styles"
            show_margin
            show_width
            show_text_align
            show_font_size
            ></style-editor>
        </div>
        <div class="column is-12">
            <show-multi-chars :multi_chars="multi_chars" />
        </div>
    </div>
</template>

<script>
import ShowMultiChars from "@/components/Question/MultiChars/ShowMultiChars"
import { defaultMultiCharsValue, defaultMultiCharsCellValue } from "./utils";
import StyleEditor from "@/components/Common/StyleEditor/StyleEditor";
import UpSelect from "@/components/UI/Inputs/UpSelect";
import UpTextinput from '../../UI/Inputs/UpTextinput.vue';
export default {
  name: "set-multi-chars",
  components: {
    ShowMultiChars,
    StyleEditor,
    UpTextinput,
    UpSelect
  },
  props: {
    value: {
      type: Object,
    },
  },
  data() {
    return {
      multi_chars: this.value ? this.value : defaultMultiCharsValue(),
    };
  },
  methods : {
    addRow(){
        this.multi_chars.data.push([])
    },
    addColumn(row_index){
        this.multi_chars.data[row_index].push(defaultMultiCharsCellValue())
    },
    removeColumn(row_index, col_index){
        this.multi_chars.data[row_index].splice(col_index, 1)
    },
    removeRow(row_index){
        this.multi_chars.data.splice(row_index, 1)
    }
  },
  watch: {
    value: {
      handler: function(new_value) {
        this.multi_chars = new_value;
      },
      deep: true,
    },
    multi_chars: {
      handler: function(new_value) {
        this.$emit("input", new_value);
      },
      deep: true,
    },
  },
};
</script>

<style scoped></style>
